module.exports = __webpack_public_path__ + "img/telegram-round-300.0e910856.png";